import { Hint } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface ITotalHoursHintProps {
  stepNumber: number
}

const TotalHoursHint = ({ stepNumber }: ITotalHoursHintProps) => {
  return (
    <Hint.Popover
      step={stepNumber}
      title={i18n.t('project_management.my_projects.hints.total_hours.title')}
      description={i18n.t('project_management.my_projects.hints.total_hours.description')}
      actionLabel={i18n.t('project_management.my_projects.hints.total_hours.action_label')}
    />
  )
}

export default observer(TotalHoursHint)
